// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectCoordinateReferenceSystemQueryResult, selectCoordinateReferenceSystemsPageLoading, selectCoordinateReferenceSystemsShowInitWaitingMessage} from '../_selectors/coordinate-reference-system.selectors';

export class CoordinateReferenceSystemsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectCoordinateReferenceSystemsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectCoordinateReferenceSystemsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectCoordinateReferenceSystemQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
